module.exports = __webpack_public_path__ + "fonts/600bda4e-11fe-4903-9a39-bb6b77389170.c991829d.woff";